/* =========================
   OnlyDiningChairs - Bundle / Popup / Price Update (Full JS)
   - Fixes qty price not updating when input is disabled / not changing
   - Avoids breaking when sale price element doesn't exist
   - Scopes total price update to the correct product form
   ========================= */

/* ---------- Popup helpers ---------- */
function removePopup() {
  const popup = document.getElementById("he-popup");
  if (popup) {
    popup.remove();
    document.body.classList.remove("overflow-hidden");
  }
}

function updateQty() {
  document.body.classList.remove("overflow-hidden");

  const idInput = document.querySelector('#he-popup .hidden-block form input[name="product-id"]');
  if (!idInput) return removePopup();

  const findCurrentPopupId = idInput.value;

  const findCurrentPopupQty = document.querySelector("#product-prw-qty");
  const selectedQty = parseInt(findCurrentPopupQty?.value || "1", 10);

  const findCurrentProductId = document.querySelector(
    `.Complementary-li .check-box-div[data-product_id="${findCurrentPopupId}"]`
  );

  if (!findCurrentProductId) return removePopup();

  const findCurrentProductQty = findCurrentProductId
    .closest("li")
    .querySelector('select[name="q"]');

  if (findCurrentProductQty) findCurrentProductQty.value = selectedQty;

  removePopup();
  select_product(findCurrentProductId, "change");
  subtotal();
}

class Popup {
  constructor(event, url) {
    this.Event = event;
    this.Url = url;
  }

  getProductData() {
    document.body.classList.add("overflow-hidden");
    this.loader(true);

    fetch(this.Url)
      .then((resp) => resp.text())
      .then((data) => {
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(data, "text/html");
        const productWrap = htmlDocument.querySelector(".product.product--small");

        if (!productWrap) {
          this.loader(false);
          return;
        }

        const product_title = productWrap.querySelector(".product__title h1")?.innerText || "";
        const price = productWrap.querySelector(".price-inventory > .price")?.innerHTML || "";
        const description =
          htmlDocument.querySelector("#tab2 .metafield-rich_text_field")?.innerHTML || "";
        const gallery = productWrap.querySelector(".product__media-wrapper");
        const form = productWrap.querySelector(".product-form");

        this.loader(false);
        this.createPopup(
          gallery || { innerHTML: "" },
          product_title,
          price,
          description,
          form || { innerHTML: "" }
        );
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
        this.loader(false);
      });
  }

  createPopup(gallery, product_title, price, description, form) {
    const div = document.createElement("div");
    div.className =
      "product product--small product--left product--thumbnail_slider product--mobile-hide grid grid--1-col grid--2-col-tablet he-popup";
    div.id = "he-popup";

    const template = `
      <div class="product-ai">
        <div class="cross-ai">
          <button class="removeButton" onclick="removePopup()">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 128 128">
              <g id="Layer_29">
                <path d="M123.7,0L64,59.9L4.1,0L0,4.1L59.7,64L0,123.9l4.1,4.1L64,68.1l59.7,59.9l4.3-4.1L68.1,64L128,4.1L123.7,0z"/>
              </g>
            </svg>
          </button>
        </div>

        <div class="product-row-ai">
          <div class="gallery-ai">${gallery.innerHTML}</div>

          <div class="product-content-ai">
            <div class="product-name-ai"><h3>${product_title}</h3></div>
            <div class="product-price-ai">${price}</div>
            <div class="product-des-ai"><p>${description}</p></div>
          </div>
        </div>

        <div class="btns-ai">
          <div class="close-ai">
            <button class="updateButton" onclick="updateQty()">Close</button>
          </div>

          <div class="side-ai">
            <div class="drop-down-ai">
              <select id="product-prw-qty">
                <option value="1" selected="selected">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
              </select>
            </div>

            <div class="add-ai">
              <button class="updateButton" onclick="updateQty()">ADD +</button>
            </div>
          </div>
        </div>

        <div class="hidden-block">
          ${form.innerHTML}
        </div>
      </div>
    `;

    div.innerHTML = template;

    const existing = document.querySelector("#he-popup");
    if (existing) {
      existing.innerHTML = template;
    } else {
      document.body.prepend(div);
    }
  }

  loader(state) {
    if (state) {
      const div = document.createElement("div");
      div.classList.add("he-loader");
      div.id = "he-loader";
      document.body.classList.add("he-overlay");

      if (!document.querySelector("#he-loader")) {
        document.body.prepend(div);
      }
    } else {
      setTimeout(() => {
        const loaderElement = document.querySelector("#he-loader");
        if (loaderElement) loaderElement.remove();
        document.body.classList.remove("he-overlay");
      }, 500);
    }
  }
}

const popupData = (e, url) => {
  e.preventDefault();
  const popup = new Popup(e, url);
  popup.getProductData();
};

/* ---------- Mobile cart-drawer behavior ---------- */
if (window.innerWidth < 980) {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) drawer.remove();

  const cartIcon = document.querySelector("#cart-icon-bubble");
  if (cartIcon) {
    cartIcon.addEventListener("click", () => {
      window.location.href = "/cart";
    });
  }
}

/* =========================
   Price Calculate (FIXED)
   ========================= */

/**
 * Helper: safe number parse
 */
const getNumber = (txt) => parseFloat((txt || "").replace(/[^\d.]/g, "")) || 0;

/**
 * Finds the "main" product quantity input on PDP and ensures it can change.
 * Your HTML showed it was disabled; if disabled, Dawn's +/- may not update its value.
 * You should ALSO remove disabled from Liquid, but this is a runtime safety.
 */
const getMainQtyInput = () => document.querySelector(".quantity-cart-add .quantity__input");

/**
 * Scope total update to correct product-form by using quantity-input data-section (if available)
 * This prevents updating the wrong element if popup duplicates IDs.
 */
const getScopedTotalEl = () => {
  const qtyWrapper = document.querySelector('.quantity-cart-add quantity-input.quantity[data-section]');
  const sectionId = qtyWrapper?.dataset?.section;

  if (sectionId) {
    return document.querySelector(`product-form[data-section-id="${sectionId}"] #alltotalprice`);
  }
  return document.querySelector(".product-form__buttons #alltotalprice");
};

/**
 * Unit price:
 * - Best: read from qty input data-price (you already output it)
 * - Fallback: read sale, else regular
 */
const getUnitPrice = () => {
  const qtyInput = getMainQtyInput();

  const fromData = parseFloat(qtyInput?.dataset?.price);
  if (!Number.isNaN(fromData) && fromData > 0) return fromData;

  const saleEl = document.querySelector(".product__info-container .price-item--sale");
  const regEl = document.querySelector(".product__info-container .price-item--regular");
  return getNumber(saleEl?.textContent) || getNumber(regEl?.textContent) || 0;
};

const subtotal = () => {
  let addonsSubtotal = 0;
  let difference = 0;

  const subtotal_div = document.getElementById("subtotal-display");
  const cart_total = getScopedTotalEl();

  const qtyInput = getMainQtyInput();
  if (!qtyInput) return;

  // runtime safety (still remove in Liquid for the real fix)
  qtyInput.removeAttribute("disabled");

  const product_qty = Math.max(1, parseInt(qtyInput.value || "1", 10));
  const unitPrice = getUnitPrice();

  // Add-ons subtotal (pre-calculated in DOM)
  const complimentary_total_prices = document.querySelectorAll(
    ".he-complimentary-slider .complementary-slide .total-price-display"
  );

  complimentary_total_prices.forEach((item) => {
    if (item.textContent.trim() !== "") {
      addonsSubtotal += getNumber(item.textContent);
    }
  });

  // Savings calculation
  const complimentary_products = document.querySelectorAll(".Complementary-li");
  complimentary_products.forEach((item) => {
    const regEl = item.querySelector(".price__container .price__sale .price-item--regular");
    const saleEl = item.querySelector(".price__container .price__sale .price-item--sale");

    const regular_price = regEl?.textContent?.trim()
      ? getNumber(regEl.textContent)
      : getNumber(saleEl?.textContent);

    const sale_price = getNumber(saleEl?.textContent) || regular_price;

    const checkbox = item.querySelector(".check-box-div input");
    const qty = parseInt(item.querySelector("#bundleQuantity")?.value || "0", 10);

    if (checkbox?.checked && regular_price && sale_price) {
      difference += (regular_price * qty) - (sale_price * qty);
    }
  });

  // Main product total + add-ons
  const product_total = unitPrice * product_qty;
  const whole_bundle_price = product_total + addonsSubtotal;

  if (subtotal_div) {
    subtotal_div.innerHTML = `Subtotal: <b>$${addonsSubtotal.toFixed(2)}</b> ( Saves <s>$${difference.toFixed(2)}</s> )`;
  }

  if (cart_total) {
    cart_total.textContent = `$${whole_bundle_price.toFixed(2)}`;
  }
};

/* ---------- Event bindings ---------- */

/**
 * Recalc when +/- clicked (delegated, works even if buttons re-render)
 */
document.addEventListener("click", (e) => {
  const btn = e.target.closest('.price-per-item__container .quantity__button[name="minus"], .price-per-item__container .quantity__button[name="plus"]');
  if (!btn) return;

  // Let Dawn update the input, then recalc next frame
  requestAnimationFrame(() => subtotal());
});

/**
 * Recalc when user types quantity manually
 */
document.addEventListener("input", (e) => {
  if (e.target.matches(".quantity-cart-add .quantity__input")) subtotal();
});
document.addEventListener("change", (e) => {
  if (e.target.matches(".quantity-cart-add .quantity__input")) subtotal();
});

// initial
document.addEventListener("DOMContentLoaded", () => {
  subtotal();
});

/* =========================
   Bundle selection logic (your original)
   ========================= */

const select_product = (e, type) => {
  const li = type === "select" ? e.target.closest("li") : e.closest("li");
  if (!li) return;

  const checkbox = li.querySelector(".check-box-div input");

  const regEl = li.querySelector(".price__container .price__sale .price-item--regular");
  const saleEl = li.querySelector(".price__container .price__sale .price-item--sale");

  const regular_price = regEl?.innerText?.trim() !== ""
    ? getNumber(regEl.textContent)
    : getNumber(saleEl?.textContent);

  const sale_price = getNumber(saleEl?.textContent) || regular_price;

  const update_price = li.querySelector(".total-price-display");
  let qty = parseInt(li.querySelector("#bundleQuantity")?.value || "0", 10);
  let total = 0;

  if (checkbox?.checked) {
    total = sale_price * qty;

    if (total > 0 && update_price) {
      update_price.innerText = `$${total.toFixed(2)}`;
      subtotal();
      return;
    }

    if (update_price) update_price.innerText = "";
    subtotal();
  } else {
    if (update_price) update_price.innerText = "";
    qty = 0;
    subtotal();
  }
};

const change_qty_product = (e) => {
  select_product(e, "select");
};


/* =========================
   Keep quantity after Add to cart (smooth + solid)
   Reset to 1 only on page refresh (no storage)
   REPLACE your previous block with this one
   ========================= */

(() => {
  let desiredQty = null;
  let guardActive = false;
  let guardStartedAt = 0;

  const GUARD_MS = 3500; // how long to protect after submit

  const getMainQtyInput = () => document.querySelector(".quantity-cart-add .quantity__input");

  const applyQty = (qty) => {
    const input = getMainQtyInput();
    if (!input) return false;

    input.removeAttribute("disabled"); // safety
    const current = Math.max(1, parseInt(input.value || "1", 10));

    if (current !== qty) {
      // Restore immediately
      input.value = String(qty);
      input.setAttribute("value", String(qty));

      // Trigger any theme / your listeners
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));

      if (typeof subtotal === "function") subtotal();
    }

    return true;
  };

  const startGuard = () => {
    guardActive = true;
    guardStartedAt = performance.now();

    const tick = () => {
      if (!guardActive) return;

      // Stop after timeout
      if (performance.now() - guardStartedAt > GUARD_MS) {
        guardActive = false;
        return;
      }

      // Keep forcing desired qty BEFORE the next paint
      if (desiredQty != null) applyQty(desiredQty);

      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  };

  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      // Only add-to-cart forms
      if (!form.matches('form[action^="/cart/add"]')) return;

      // Ensure it's the real PDP product form (prevents popup/duplicate forms)
      const pf = form.closest("product-form");
      if (!pf) return;

      const qtyInput = getMainQtyInput();
      if (!qtyInput) return;

      desiredQty = Math.max(1, parseInt(qtyInput.value || "1", 10));

      // Set immediately (so it stays right from the start)
      applyQty(desiredQty);

      // Start guard (prevents the "1 then back" flicker)
      if (!guardActive) startGuard();
    },
    true
  );
})();

